import React from 'react';
import { businessServices } from '../../data/businessServices';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const Networks = () => {
  const networksService = businessServices.find(service => service.title === "Rețele Private");

  return (
    <>
      <Hero
        title="Rețele Private"
        subtitle="Soluții complete de rețele private și VPN pentru conectarea sigură a locațiilor"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-business-networks.jpg"
        icon={networksService?.icon}
        iconLabel={networksService?.title}
      />

      {networksService && (
        <ServiceSection
          service={networksService}
          index={0}
          pricingFirst
          id="tarife"
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Networks;
